const Twlang = {
  登录: '登入',
  密码: '密碼',
  '邮箱账号/会员账号': '郵箱帳號/會員帳號',
  请选择地区: '請選擇地區',
  充值游戏: '充值遊戲',
  账号: '帳號',
  请选择角色信息: '請選擇角色信息',
  地区: '地區',
  切换地区: '切換地區',
  请选择游戏: '請選擇遊戲',
  请选择区服: '請選擇區服',
  请选择支付方式: '請選擇支付方式',
  请选择充值金额: '請選擇充值金額',
  请确认支付信息: '請確認支付信息',
  '抱歉，您的充值失败': '抱歉，您的充值失敗',
  再次充值: '再次充值',
  游戏: '遊戲',
  服务器: '服務器',
  角色: '角色',
  订单金额: '訂單金額',
  立即充值: '立即充值',
  请您在新打开的页面完成支付: '請您在新打開的頁面完成支付',
  完成支付: '完成支付',
  支付出现问题: '支付出現問題',
  '恭喜您，充值成功': '恭喜您，充值成功',
  继续充值: '繼續充值',
  个人中心: '個人中心',
  充值记录: '充值記錄',
  退出: '退出',
  全部: '全部',
  支付失败: '支付失敗',
  购买失败: '購買失敗',
  购买中: '購買中',
  订单状态: '訂單狀態',
  充值成功: '充值成功',
  搜索: '搜索',
  充值时间: '充值時間',
  充值类型: '充值類型',
  游戏名称: '遊戲名稱',
  详情: '詳情',
  查看详情: '查看詳情',
  使用第三方登录: '使用第三方登錄',
  '如果您用信用卡支付，请确认您的充值金额没有超过该信用卡的线上交易限额':
    '如果您用信用卡支付，請確認您的充值金額沒有超過該信用卡的線上交易限額',
  'MyCard系统于每周一早上8:00 - 9:30进行系统维护，使用MyCard储值的玩家请在维护时间过后再进行储值':
    'MyCard系統於每周一早上8:00 - 9:30進行系統維護，使用MyCard儲值的玩家請在維護時間過後再進行儲值',
  '如果您在储值过程中有任何疑问或问题，可与我们的客服联系，我们会给予您必要的帮助':
    '如果您在儲值過程中有任何疑問或問題，可與我們的客服聯系，我們會給予您必要的幫助',
  充值中心: '儲值中心',
  区服: '區服',
  订单详情: '訂單詳情',
  订单号: '訂單號',
  充值平台币: '充值平台幣',
  充值方式: '充值方式',
  商品项: '商品項',
  钱包: '錢包',
  钱包余额: '錢包餘額',
  请填写账号: '請填寫帳號',
  请填写密码: '請填寫密碼',
  请先选择游戏: '請先選擇遊戲',
  请先选择支付方式: '請先選擇支付方式',
  请重新登录: '請重新登錄',
  请先选择充值金额: '請先選擇充值金額',
  请先选择区服: '請先選擇區服',
  请先选择角色: '請先選擇角色',
  温馨提示: '溫馨提示',
  充值未完成: '充值未完成',
  暂无数据: '暫無數據',
  '登录已过有效期，请重新登录': '登錄已過有效期，請重新登錄',
  语言: '語言',
  额外赠送: '額外贈送',
  Google登录: 'Google登入',
  Facebook登录: 'Facebook登入',
  T币: 'T幣',
  客服中心: '客服中心',
  欢迎: '歡迎',
  一般充值: '一般儲值',
  大额充值: '大額儲值',
  充值: '儲值',
  支付金额: '支付金額',
  立即支付: '立即支付',
  个人: '個人',
  退出账号: '退出帳號',
  客服: '客服',
  帐号类: '帳號類',
  储值类: '儲值類',
  登录类: '登入類',
  VIP类: 'VIP類',
  游戏类: '遊戲類',
  进入游戏看不到角色: '進入遊戲看不到角色',
  '如果出现这种情况，有以下几种可能': '如果出現這種情況，有以下幾種可能',
  '进错了区服，请检查确认': '進錯了伺服器，請檢查確認',
  '之前用游客帐号登入，然后不小心注销掉了，现在换帐号进入是看不到角色的。请联系Facebook客服处理，处理过程中可能需要提供有效的储值凭证':
    '之前用遊客帳號登入，然後不小心注銷掉了，現在換帳號進入是看不到角色的。請聯繫Facebook客服處理，處理過程中可能需要提供有效的儲值憑證',
  '如果您排除上述两种可能，则属于其他低频率发生的异常，请联系Facebook客服处理':
    '如果您排除上述兩種可能，則屬於其他低頻率發生的異常，請聯繫Facebook客服處理',
  如何修改密码: '如何修改密碼',
  修改密码前请先确认您的登入方式: '修改密碼前請先確認您的登入方式',
  '如果使用会员账号登入，请点击登录介面修改密码来修改您的密码。修改过程中需要登入信箱':
    '如果使用會員帳號登入，請點擊“登入介面-修改密碼”來修改您的密碼。修改過程中需要登入信箱',
  '如果使用游客帐号登入，暂时无法直接修改密码，您登入游戏后会提示帐号升级，请绑定Facebook、Google、或者常用信箱。如果绑定的是常用信箱，可以参考会员帐号登入的方式来修改密码':
    '如果使用遊客帳號登入，暫時無法直接修改密碼，您登入遊戲後會提示帳號升級，請綁定Facebook、Google、或者常用信箱。如果綁定的是常用信箱，可以參考會員帳號登入的方式來修改密碼',
  '如果使用Facebook或Google帐号登入，如果帐号有安全隐患请修改Facebook或Google帐号的登入密码':
    '如果使用Facebook或Google帳號登入，如果帳號有安全隱患請修改Facebook或Google帳號的登入密碼',
  如果有其它的疑问请联系Facebook客服处理:
    '如果有其他的疑問請聯繫Facebook客服處理',
  储值不到账: '儲值不到賬',
  '储值不到账属于低频率事件，如果出现请不要着急，先确认您的储值方式，然后根据以下步骤操作':
    '儲值不到賬屬於低頻率事件，如果出現請不要著急，先確認您的儲值方式，然後根據以下步驟操作',
  '如果使用Apple store充值': '如果使用App Store儲值',
  '先在游戏内点击相同档位元宝进行储值，然后不要付款，看看是否补发元宝':
    '先在遊戲內點擊相同擋位元寶進行儲值，然後不要付款，看看是否補發元寶',
  '如果未补发请联系apple客服申请退款，退款后重新储值':
    '如果元寶未補發請繫Apple客服申請退款，退款後再重新儲值',
  '如果无法顺利申请退款，请您准备好储值凭证（需带有储值时间，金额，订单号，可在apple帐号信箱中找到），然后联系Facebook客服处理':
    '如果無法順利申請退款，請您準備好儲值憑證（需帶有儲值時間，金額，訂單號，可在Apple帳號信箱中找到），然後聯繫Facebook客服處理',
  '如果使用Google play充值': '如果使用Google Play儲值',
  '如果未补发，请您准备好储值凭证（需带有储值时间，金额，订单号，可在Google帐号信箱中找到），然后联系Facebook客服处理':
    '如果未補發，請您準備好儲值憑證（需帶有儲值時間，金額，訂單號，可在Google帳號信箱中找到），然後聯繫Facebook客服處理',
  如果使用MyCard充值: '如果使用MyCard儲值',
  请你点击: '請你點擊',
  '登录您的游戏帐号，然后点击wallet查看钱包余额，确认是否充值到余额中。注意余额1T币等于0.1美元':
    '登入您的遊戲帳號，然後點擊wallet查看錢包餘額，確認是否儲值到餘額中。注意餘額1T幣等於0.1美元',
  '如果充值到余额，您可以在网页中使用余额支付即可':
    '如果儲值到餘額，您可以在網頁中使用餘額支付即可',
  '如果未充值到余额，请您找到充值小票或订单信息（点卡充值需带有序号和密码，会员扣点需要有相关扣点记录），然后联系Facebook客服处理':
    '如果未儲值到餘額，請您找到儲值小票或訂單資訊（點卡儲值需帶有序號和密碼，會員扣點需要有相關扣點記錄），然後聯繫Facebook客服處理',
  如果使用Mol充值: '如果使用Mol儲值',
  '如果未充值到余额，请您找到充值小票或订单信息（MolPoints Card/MOL direct Top Up需带有MP或MPO序号和SN，Mol Points E-wallet/Mol Points需要有相关扣点记录），然后联系Facebook客服处理':
    '如果未儲值到餘額，請您找到儲值小票或訂單資訊（Mol Points Card/MOL direct Top Up需帶有MP或MPO序號和SN、Mol Points E-wallet/Mol Points需要有相關扣點記錄），然後聯繫Facebook客服處理',
  如果使用Paymentwall充值: '如果使用Paymentwall儲值',
  '请准备好扣款记录（需要带有扣款时间，金额和订单号），然后联系Facebook客服处理':
    '請準備好扣款記錄（需要帶有扣款時間，金額和訂單號），然後聯繫Facebook客服處理',
  如何使用点卡充值: '如何使用點卡儲值',
  '如果您希望在游戏内使用点卡充值，目前不是所有产品都支持，且只有安卓系统支持。请您打开产品对应的Facebook首页，如果产品支持，Facebook首页会有相关介绍，需要您重新下载一个游戏安装包':
    '如果您希望在遊戲內使用點卡儲值，目前不是所有產品都支持，且只有安卓系統支持。請您打開產品對應的Facebook首頁，如果產品支持，Facebook首頁會有相關介紹，需要您重新下載一個遊戲安裝包',
  您可以使用我们充值网址: '您可以使用我們儲值網址',
  '登录后可使用更多充值方式，新游戏可能暂时不支持，请留意后续开放':
    '登入後可使用更多儲值方式，新遊戲可能暫時不支持，請留意後續開放',
  '使用点卡充值如何充值到余额，不直接充值到游戏中':
    '使用點卡儲值如何儲值到餘額，不直接儲值到遊戲中',
  '当您使用的点卡额度低于充值的元宝额度，您不会获得游戏元宝，将会直接充值到帐号余额。建议您使用小额度的点卡，然后游戏内点击最高挡位元宝进行操作':
    '當您使用的點卡額度低於儲值的元寶額度，您不會獲得遊戲元寶，將會直接儲值到帳號餘額。建議您使用小額度的點卡，然後遊戲內點擊最高擋位元寶進行操作',
  '登录卡加载，黑屏': '登入卡加載、黑屏',
  '一般这种情况为网络信号不好导致，可以尝试在手机wifi和流量信号之间切换，然后重新登录试试':
    '一般這種情況為網路信號不好導致，可以嘗試在手機wifi和流量信號之間切換，然後重新登入試試',
  '如果游戏加载介面有一键恢复按钮（通常位于右下角），请点击然后重新加载登录':
    '如果遊戲加載介面有一鍵恢復按鈕（通常位於右下角），請點擊然後重新加載登入',
  您也可以尝试卸载后重新安装游戏后登录查看是否能解决:
    '您也可以嘗試解除安裝後重新安裝遊戲後登入查看是否能解決',
  VIP经理是什么: 'VIP經理是什麼',
  'VIP经理是针对至尊VIP玩家提供专属服务的秘书。针对至尊VIP玩家提供游戏问题快速解答，游戏建议收集重点反馈，不定期VIP礼包发放，VIP专属活动组织，生日福利等':
    'VIP經理是針對至尊VIP玩家提供專屬服務的。針對至尊VIP玩家提供遊戲問題快速解答，遊戲建議收集重點回饋、不定期VIP禮包發放、VIP專屬活動組織、生日福利等',
  怎样成为至尊VIP玩家: '怎樣成爲至尊VIP玩家',
  '我们会综合玩家的游戏内活跃程度，充值情况等因素来判断，符合标准的玩家游戏内会有弹窗提醒或者收到邀请邮件，弹窗或邮件中会有我们VIP经理的联系方式，直接添加即可':
    '我們會綜合玩家的遊戲內活躍程度，儲值情況等因素來判斷，符合標準的玩家遊戲內會有彈窗提醒或者收到邀請郵件，彈窗或郵件中會有我們VIP經理的聯繫方式，直接添加即可',
  为什么掉落物品都是绑定材料: '爲什麼掉落物品都是綁定材料',
  '掉落的物品都是随机，也有不绑定材料出现，建议多多尝试':
    '掉落的物品都是隨機的，也有不綁定材料出現，建議多多嘗試',
  为什么总有高战力玩家抢boss: '爲什麼總有高戰力玩家搶boss',
  '游戏内部分场景有一定PK性质，玩家可以切磋交流，建议您可以和其他玩家组队或者换个时间攻打，多多参加活动或者适量充值提升战力':
    '遊戲內部分場景有一定PK性質，玩家可以切磋交流，建議您可以和其他玩家組隊或者換個時間攻打，多多參加活動或者適量儲值提升戰力',
  '离线挂机使用经验药有用吗？该怎么提升效率':
    '離線掛機使用經驗藥有用嗎？該怎麼提升效率',
  '离线挂机时间充足情况下使用经验药会有加成，同时您可以佩戴经验鬼怪以及装备经验仙符提升战力等级来提升挂机效率':
    '離線掛機時間充足情況下使用經驗藥會有加成，同時您可以佩戴經驗鬼怪以及裝備經驗仙符提升戰力等級來提升掛機效率',
  市场买的装备在背包找不到: '市場買的裝備在背包找不到',
  '市场购买后的装备会在您的邮件，建议您及时查看领取':
    '市場購買後的裝備會在您的郵件，建議您及時查看領取',
  'PK值在哪里看？为什么会红名？如何去掉红名':
    'PK值在哪里看？為什麼會紅名？如何去掉紅名',
  '玩家在默认和平的地图上每击杀一个玩家将增加一点PK值，PK值达到10点不能再继续杀人。另外，每在线30分钟会减少1点PK值。您可以在左上角的Buff里面查看自己的PK值':
    '玩家在默認和平的地圖上每擊殺一個玩家將增加一點PK值，PK值達到10點不能再繼續殺人。另外，每線上30分鐘會減少1點PK值。您可以在左上角的buff裏面查看自己的PK值',
  '套装石怎么打不到？哪里可以获取': '套裝石怎麼打不到？哪里可以獲取',
  '击杀寒冰炼狱的世界BOSS，上古禁地BOSS，高等级的个人BOSS会掉落套装石，击杀上古禁地的精英怪掉落诛仙套碎片，可合成套装石':
    '擊殺寒冰煉獄的世界BOSS，上古禁地BOSS，高等級的個人BOSS會掉落套裝石，擊殺上古禁地的精英怪掉落誅仙套碎片，可合成套裝石',
  仙盟神兽怎么攻打: '仙盟神獸怎麼攻打',
  '喂养到一定阶段即可攻打仙盟神兽，每周五次机会，成功和失败都会扣除次数，同时奖励和攻打难度受喂养阶段和世界等级影响':
    '餵養到一定階段即可攻打仙盟神獸，每週五次機會，成功和失敗都會扣除次數，同時獎勵和攻打難度受餵養階段和世界等級影響',
  怎么查看提升好友亲密度: '怎麼查看提升好友親密度',
  '您可以点击对应好友，点击心形查看亲密值，通过赠送鲜花、组队通关四灵古阵副本、组队击杀boss之家boss等方式提升':
    '您可以點擊對應好友，點擊心形查看親密值，通過贈送鮮花、組隊通關四靈古陣副本、組隊擊殺boss之家boss等方式提升',
  '0元购昨天买完没有返还，页面也不见了': '0元購昨天買完沒有返還，頁面也不見了',
  '在活动时间内参与0元购，都会在指定天数后原额返还绑元、元宝。返还时间按天计算，如7天后返还，在7天后的0点即可领取全额返还的元宝':
    '在活動時間內參與0元購，都會在指定天數後原額返還綁元、元寶。返還時間按天計算，如7天後返還，在7天後的0點即可領取全額返還的元寶',
  活动购买的神戒为什么没有: '活動購買的神戒為什麼沒有',
  降妖神戒等级到达巅峰30级可以开启和查看到:
    '降妖神戒等級到達巔峰30級可以開啟和查看到',
  为什么结婚了不能预约婚礼: '為什麼結婚了不能預約婚禮',
  '您需要缔结元宝的婚礼才会有婚礼预约次数，绑定元宝是没有的':
    '您需要締結元寶的婚禮才會有婚禮預約次數，綁元是沒有的',
  '盟主长时间不上线了，怎么换掉他': '盟主長時間不上線了，怎麼換掉他',
  '仙盟盟主连续48小时未上线，盟主职位将自动转让给副盟主（如果不存在副盟主，将自动转让给历史贡献最高的玩家）':
    '仙盟盟主連續48小時未上線，盟主職位將自動轉讓給副盟主（如果不存在副盟主，將自動轉讓給歷史貢獻最高的玩家）',
  副本双倍活动中为什么装备副本二星装没有双倍:
    '副本雙倍活動中為什麼裝備副本二星裝沒有雙倍',
  双倍活动是概率双倍不是物品数量双倍: '雙倍活動是概率雙倍不是物品數量雙倍',
  怎么离婚: '怎麼離婚',
  '点击仙缘结婚页面，寻找对应的NPC会有离婚的选项':
    '點擊仙緣結婚頁面，尋找對應的NPC會有離婚的選項',
  男职业总是掉落女职业的装备: '男職業總是掉落女職業的裝備',
  '装备掉落都是随机职业的，您可以上架和其他职业玩家交易本职业需要的装备':
    '裝備掉落都是隨機職業的，您可以上架和其他職業玩家交易本職業需要的裝備',
  T币使用说明: 'T幣使用說明',
  'T币是购买少女芯平台上虚拟商品的通用代币，目前可用于购买少女芯平台上的水晶道具。':
    'T幣是購買少女芯平臺上虛擬商品的通用代幣，目前可用於購買少女芯平臺上的元寶道具。',
  '1.T币和美元的兑换比例为：1T=0.1美元。':
    '1.T幣和美元的兌換比例為：1T=0.1美元。',
  '2.若支付金额>应付金额（比如元宝价格为9.99美金，您支付了10美金），则您的支付金额超出部分（0.1美金）将转换为T币存入您的钱包。':
    '2.若支付金額>應付金額（比如元寶價格為9.99美金，您支付了10美金），則您的支付金額超出部分（0.1美金）將轉換為T幣存入您的錢包。',
  '3.同理，若支付金额< 应付金额，本次支付金额将转换为T币存入您的钱包。':
    '3.同理，若支付金額< 應付金額，本次支付金額將轉換為T幣存入您的錢包。',
  溫馨提示: '溫馨提示',
  '1.如果您用信用卡支付，请确认您的储值金额没有超过该信用卡的线上交易限额。':
    '1.如果您用信用卡支付，請確認您的儲值金額沒有超過該信用卡的線上交易限額。',
  '2.MyCard系统于每周一早上8:00 - 9:30进行系统维护，使用MyCard储值的玩家请在维护时间过后再进行储值。':
    '2.MyCard系統於每週一早上8:00 - 9:30進行系統維護，使用MyCard儲值的玩家請在維護時間過後再進行儲值。',
  '如果您在储值过程中有任何疑问或问题，可与我们的客服联系，我们会给予您必要的帮助。客服邮箱：hwkf@99trillion.com，或前往':
    '如果您在儲值過程中有任何疑問或問題，可與我們的客服聯繫，我們會給予您必要的幫助。客服郵箱：hwkf@99trillion.com，或前往',
  '寻求帮助。': '尋求幫助。',
  首页: '首頁',
  推荐游戏: '推薦遊戲',
  游戏下载: '遊戲下載',
  热门活动: '熱門活動',
  更多资讯: '更多資訊',
  '©2019 Trigirls Studio 工作室版权所有，页面内所有提及商标及素材均为其所有。':
    '©2019 Trigirls Studio 工作室版權所有，頁面內所有提及商標及素材均為其所有。',
  隐私协议: '隱私協議',
  用户协议: '用戶協議',
  请选择要充值的游戏产品: '請選擇要儲值的遊戲產品',
  更换地区: '更換地區',
  游戏充值: '遊戲儲值',
  更换游戏: '更換遊戲',
  请选择充值数量: '請選擇儲值數量',
  wallet: '錢包',
  应付金额: '應付金額',
  确认订单: '確認訂單',
  充值说明: '儲值說明',
  粉丝页: '粉絲頁'
};
export default Twlang;



// WEBPACK FOOTER //
// ./src/common/lang/zh-tw.js